<template>
  <el-container>
    <el-form ref="ruleForm" :model="ruleForm" label-width="90px" :rules="rules">
      <el-form-item label="系统名称" prop="server_type">
        <el-select v-model="ruleForm.server_type" @change="serverTypeChange">
          <el-option
            v-for="item in serverVersionList"
            :key="item.value"
            :label="item.key"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item ref="version_ref" label="版本号" prop="version">
        <el-select v-model="ruleForm.version" @change="versionChange">
          <el-option
            v-for="it in versionList"
            :key="it.version"
            :label="it.version"
            :value="it.version">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item ref="comment_ref" label="发布内容" prop="comment">
        <el-input type="textarea" v-model="ruleForm.comment" :rows="8" sizeable readonly />
      </el-form-item>
      <el-form-item>
        <el-button class="btn_dialog" @click="$emit('tableCloseDialog')">取消</el-button>
        <el-button class="btn_dialog cz" @click="resetForm">重置</el-button>
        <el-button class="btn_dialog qd" @click="confirm">确认</el-button>
      </el-form-item>
    </el-form>
  </el-container>
</template>

<script>
import Backend from '@/api/backend'
import BasicDataHelper from '@/api/basic_data_helper'

export default {
  name: '',
  data () {
    return {
      serverVersionList: [],
      versionList: [],
      ruleForm: {
        server_type: '',
        version: '',
        comment: ''
      },
      rules: {
        server_type: [
          { required: true, message: '请选择系统名称', trigger: 'change' }
        ],
        version: [
          { required: true, message: '请选择版本号', trigger: 'change' }
        ]
      }
    }
  },

  created () {
    this.serverVersionList = BasicDataHelper.getServerVersion(this, 3)
  },

  props: ['rowData'],

  methods: {
    getVersionList (serverType) {
      Backend.post(this, 'version_manage/get_version_list', { server_type: serverType }).then(data => {
        this.versionList = data.items
      }).catch(e => {
        this.versionList = []
      })
    },
    serverTypeChange (serverType) {
      this.$refs.version_ref.resetField()
      this.$refs.comment_ref.resetField()
      this.getVersionList(serverType)
    },
    versionChange (version) {
      this.ruleForm.comment = this.versionList.find(it => it.version === version).comment
    },
    resetForm () {
      this.$refs.ruleForm.resetFields()
    },
    confirm () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const params = { device_code: this.rowData.device_code, ...this.ruleForm }
          Backend.post(this, 'version_manage/package_push', params).then((res) => {
            this.$message.success('任务下发成功!')
            this.$emit('tableCloseDialog')
          }).catch(e => {})
        }
      })
    }
  }
}
</script>
